import { morph } from '@theme/morph';

class PrintingTypeSwitch extends HTMLElement {
  #abortController;

  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
    this.addEventListener('change', this.#handleChange);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
    this.removeEventListener('change', this.#handleChange);
    this.#abortController?.abort();
  }

  #handleClick = (event) => {
    const link = event.target instanceof Element ? event.target.closest('[data-product-switch-link]') : null;

    if (!(link instanceof HTMLAnchorElement)) return;
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.classList.contains('is-active')) return;

    const targetUrl = link.dataset.productUrl || link.href;
    const currentUrl = this.dataset.currentProductUrl || window.location.pathname;

    if (!targetUrl || targetUrl === currentUrl) return;

    event.preventDefault();
    this.#switchProduct(targetUrl);
  };

  #handleChange = (event) => {
    if (!(event.target instanceof HTMLSelectElement)) return;

    const selectedOption = event.target.options[event.target.selectedIndex];
    if (!(selectedOption instanceof HTMLOptionElement)) return;

    const targetUrl = selectedOption.dataset.productUrl || selectedOption.value;
    const currentUrl = this.dataset.currentProductUrl || window.location.pathname;

    if (!targetUrl || targetUrl === currentUrl) return;

    this.#switchProduct(targetUrl);
  };

  async #switchProduct(targetUrl) {
    const main = document.querySelector('main');
    if (!main) {
      window.location.href = targetUrl;
      return;
    }

    this.#abortController?.abort();
    this.#abortController = new AbortController();

    this.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(targetUrl, { signal: this.#abortController.signal });
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const newMain = html.querySelector('main');

      if (!newMain) {
        window.location.href = targetUrl;
        return;
      }

      morph(main, newMain);
      history.replaceState({}, '', targetUrl);
      this.dataset.currentProductUrl = targetUrl;
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') return;
      console.error(error);
      window.location.href = targetUrl;
    } finally {
      this.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('printing-type-switch')) {
  customElements.define('printing-type-switch', PrintingTypeSwitch);
}
